export enum DefaultField {
    None = 'None',
    CreatedByUserId = 'CreatedByUserId',
    CreatedByUserName = 'CreatedByUserName',
    CreatedByUserEmail = 'CreatedByUserEmail',
    CreatedByUserMobileNumber = 'CreatedByUserMobileNumber',
}